import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import { Editor, EditorUtils } from "@ep/editor";
import { isJsonString } from "../../lib/utils";
import styles from "../../styles/texts.module.scss";
import { textContentPropType } from "../../lib/dataShapes";
import ReferenceCitation from "./ReferenceCitation";

const referenceDecorator = {
  strategy: EditorUtils.findTextByEntityType("REFERENCE"),
  component: ReferenceCitation
};

const TextContent = ({ content, className }) => {
  const editorContent = isJsonString(content) ? JSON.parse(content) : content;
  return (
    <div className={classNames(styles.plainText, className)}>
      <Editor
        customDecorators={referenceDecorator}
        editorContent={editorContent}
        readOnly={true}
      />
    </div>
  );
};

TextContent.propTypes = {
  content: textContentPropType,
  className: PropTypes.string
};

TextContent.defaultProps = {
  className: ""
};

export default TextContent;
